import { Button, withStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { compose } from 'recompose';
import appConstants from '../../../appConstants';
import withRouter from '../../../routes/withRouter';
import { withUserProfile } from '../../../userProfile/userProfileContext';
import NetworkView from './NetworkView';
import TerminalView from './TerminalView';
import ViewOptions, { VIEWS } from './ViewOptions';
import { RMAXLogger } from '../../../services/LoggerService/RMAXLogger';

const styles = (theme) => ({
  container: {
    height: '100%',
    padding: '0 16',
    color: 'white',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    justifyContent: 'space-between'
  },
  viewOptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    margin: '0 -16',
    padding: '0 16',
    borderBottom: '1px solid #3a3a3a'
  },
  viewContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    flex: 1
  },
  quickFilterContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  gridsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  grid: {
    display: 'flex',
    flex: 1
  },
  footer: {
    display: 'flex',
    padding: '8 80 8 0',
    boxSizing: 'border-box',
    justifyContent: 'flex-end'
  },
  group: {
    display: 'flex',
    flexDirection: 'row'
  },
  label: {
    color: theme.TextColor
  },
  viewContentHidden: {
    display: 'none',
    flexDirection: 'column',
    flex: 1
  },
  viewContentVisible: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  }
});


const ShipmentForecast = ({ classes, userData, router, glEventHub }) => {
  const [currentView, setCurrentView] = useState(VIEWS.TERMINAL.value);
  const [renderNetworkView, setRenderNetworkView] = useState(false);
  const [quickFilter, setQuickFilter] = useState(null);

  useEffect(() => {
    glEventHub.on('updateQuickFilter', updateQuickFilter);
  }, [glEventHub]);

  const updateQuickFilter = (quickFilterData) => {
    if (quickFilterData.filterName === appConstants.IBPLANNING_QUICKFILTER_NAMES.SHIPMENT_FORECAST) {
      setQuickFilter(quickFilterData.eventData);
    }
  };

  const updatedView = (event) => {
    const selectedView = event.target.value;
    setCurrentView(selectedView);
    if (!renderNetworkView && selectedView === VIEWS.NETWORK.value) {
      setRenderNetworkView(true);
    }
  };

  const navigateToIBPlanning = () => {
    router.navigate(appConstants.NAV_URLS.IBPLANNING_SHIPMENTS);
  };

  useEffect(() =>{
    RMAXLogger.addAction('ShipmentForecast load', {
      terminalCode: userData.userProfile.terminal.code,
      userId: userData.userProfile.userId
    })
    return () => {
      RMAXLogger.addAction('ShipmentForecast close', {
        terminalCode: userData.userProfile.terminal.code,
        userId: userData.userProfile.userId
      })
    }
  },[])

  const currentTerminal = userData.userProfile.terminals.find((terminal) => terminal.terminalId === userData.userProfile.terminal.id);
  return (
    <div className={classes.container}>
      <div className={classes.viewOptionContainer}>
        <ViewOptions onViewUpdate={updatedView} selectedView={currentView}/>
      </div>
      <div className={classes.viewContainer}>
        <div className={classes.gridsContainer}>
          <div
            className={`${
              currentView === VIEWS.TERMINAL.value ? classes.viewContentVisible : classes.viewContentHidden
            }`}>
            <TerminalView terminal={currentTerminal} userData={userData} quickFilter={quickFilter} />
          </div>
          {renderNetworkView && (
            <div
              className={`${
                currentView === VIEWS.NETWORK.value ? classes.viewContentVisible : classes.viewContentHidden
              }`}>
              <NetworkView quickFilter={quickFilter} />
            </div>
          )}
        </div>
      </div>
      <div className={classes.footer}>
        <Button variant="outlined" color="primary" onClick={navigateToIBPlanning}>
          Close
        </Button>
      </div>
    </div>
  );
};

export default compose(withStyles(styles), withUserProfile, withRouter)(ShipmentForecast);
